module.exports = __webpack_public_path__ + "img/addbtngreen.5cd708a4.svg";